import React from 'react';

import { LazyRender } from 'src/components/molecules/LazyRender/LazyRender';
import { SectionContainer } from 'src/components/molecules/SectionContainer/SectionContainer';
import type { RecommendedProductsProps } from 'src/components/organisms/RecommendedProducts/RecommendedProducts';
import { RecommendedProducts } from 'src/components/organisms/RecommendedProducts/RecommendedProducts';
import * as styles from './ProductCarouselRecommendationsSection.style';

const RECOMMENDED_PRODUCTS_LAZY_LOAD_MARGIN = '200px';

export interface ProductCarouselRecommendationsSectionProps extends RecommendedProductsProps {
  trackingPosition: number;
  trackingTitle: string;
}

export const ProductCarouselRecommendationsSection = ({
  enableFreeDomesticDeliveryLabels,
  servingConfig,
  trackingPosition,
  trackingTitle,
}: ProductCarouselRecommendationsSectionProps) => {
  return (
    <SectionContainer columnsXL={10} maxWidth="max" wrapperStyles={styles.wrapper}>
      <LazyRender
        options={{
          rootMargin: RECOMMENDED_PRODUCTS_LAZY_LOAD_MARGIN,
        }}
      >
        <RecommendedProducts
          enableFreeDomesticDeliveryLabels={enableFreeDomesticDeliveryLabels}
          servingConfig={servingConfig}
          trackingPosition={trackingPosition}
          trackingTitle={trackingTitle}
        />
      </LazyRender>
    </SectionContainer>
  );
};
